export class SessionModel {
  access_token?: string;
  user?: any;
  verification_required?: any;
  data?: any;
}
